<template lang="pug">
    .ai-tools-tabs
        tabs(:items="tabs" :active-tab="activeTab" @click="activateTab")
        slot
</template>

<i18n>
{
    "de": {
        "Chats": "Chats",
        "Knowledge Base": "Wissensdatenbank",
        "Prompt Templates": "Prompt-Vorlagen"
    }
}
</i18n>

<script>
// Shared tab bar of the "AI Tools" area: the chatbot's chats, the knowledge
// base (shared by the chatbot and KI-Inhalte) and the generative-media prompt
// templates — each tab only shows when its extension is enabled.
import Tabs from '@/components/Tabs'
import { useSetupStore } from '@/stores'

export default {
    name: 'AiToolsTabs',
    components: {
        Tabs
    },
    computed: {
        enabledExtensions() {
            return useSetupStore().enabledExtensions
        },
        // ai-image-edit is system-wide (never template-listed) — gated against the
        // CMS's ACTIVE extensions, like the product form's hasImageEditFeature.
        activeExtensions() {
            return useSetupStore().activeExtensions
        },
        tabs() {
            const items = []

            if (this.enabledExtensions.includes('chatbot')) {
                items.push({
                    name: this.$t('Chats'),
                    path: '/chatbot/chats',
                    icon: { name: 'comments', group: 'fas' }
                })
            }

            // shared by the chatbot and KI-Inhalte
            if (this.setupStore.hasKnowledgeBase) {
                items.push({
                    name: this.$t('Knowledge Base'),
                    path: '/ai-tools/knowledge-base',
                    icon: { name: 'book', group: 'fas' }
                })
            }

            if (this.activeExtensions.includes('ai-image-edit')) {
                items.push({
                    name: this.$t('Prompt Templates'),
                    path: '/ai-tools/prompt-templates',
                    icon: { name: 'wand-magic-sparkles', group: 'fas' }
                })
            }

            return items
        },
        activeTab() {
            if (this.$route.path.startsWith('/chatbot/chat/')) return '/chatbot/chats'
            return this.$route.fullPath
        },
        setupStore() {
            return useSetupStore()
        }
    },
    methods: {
        activateTab(item) {
            return this.setupStore.activateTab(item)
        }
    }
}
</script>
